import ArrowRightRoundedIcon from "@mui/icons-material/ArrowRightRounded";

export default function ExpandIcon() {
  return <ArrowRightRoundedIcon />;
}
